import SubscriptionPlans
from "./components/SubscriptionPlans";

export default function SubscriptionPage() {

  return (
    <SubscriptionPlans />
  );

}